import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import { ManageSubDeleteDialogAction } from './manage-sub-delete-dialog.action';
import { ITimeoutService, IWindowService } from 'angular';
import FamilyPlanService from '../famil-plan.service';
import { FamilyPlanTypes } from '../../common/services/package/package.model';

/* @ngInject */
export default class ManageSubDeleteDialogController implements ActionHandler {
  private dialogElement;
  private type: FamilyPlanTypes;

  constructor(
    private $element,
    private $state,
    private actionDispatcher: ActionDispatcherService,
    private $timeout: ITimeoutService,
    private $window: IWindowService,
    private familyPlanService: FamilyPlanService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element.find('#manage-sub-delete-dialog').remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof ManageSubDeleteDialogAction ) {
      this.type = action.type;
      this.openDialog();
    }
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.$timeout(() => {
      this.dialogElement.open();
    });
  }

  public deleteConfirm() {
   this.familyPlanService.cancelBySubMember(this.type).then(response =>{
    this.close();
    this.$state.go('myAccount');
   });
  }
  

  private refresh() {
    window.location.reload();
}

  public isActive(destination: string) {
    return destination === this.$window.location.pathname;
  }

  private close() {
    this.dialogElement.close();
  }

  public onClose() {
    this.close();
  }
  
  public isDuoPackage() {
    return this.type == FamilyPlanTypes.DUO;
  }

}



// WEBPACK FOOTER //
// ./src/app/family-plan/manage-sub-delete-dialog/manage-sub-delete-dialog.controller.ts